import { useContext, useEffect, useState } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import FreeLancingWorkLayout from '../../freelancing-job/FreeLancingWorkLayout';
import { SmartContext } from '../../../../../library/Core/SmartContext';
import PageBuilder from '../../../../../library/Builders/PageBuilder/PageBuilder';
import { addUserSpecificDomains } from '../../../../../library/Service/domainService';
import { handleCompleteLater, handleNext, onCurrentJobSelectionChange } from './FreeLancingWorkOutcomeActions';
import { DispatchEvent, State } from '../../../../../library/Core/SmartTypes';
import smartReducer from '../../../../../library/Core/SmartReducer';
import { GlobalContext } from '../../../../../library/Core/GlobalContext';
import { getDomainValueForCode } from '../../../../../library/Core/SmartFunctions';
import OutcomeInformationLayout from '../../OutcomeInformationLayout';

const FreeLancingWorkOutcome = () => {
    const { globalState } = useContext(GlobalContext);
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState('');

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {
            NEXT: handleNext,
            I_LL_DO_THIS_LATER: handleCompleteLater,
            ROUTER_NAVIGATE: navigate,
            isCurrent: onCurrentJobSelectionChange,
            REDIRECT: setRedirectUrl
        },
    } as any);

    const { formConfig, data, routeInfo } = useLoaderData() as State;

    let program_name = getDomainValueForCode(state?.data?.selectedInstitute?.programId,'ALL_PROGRAM_CODE',state);
    let institute_name = getDomainValueForCode(state?.data?.selectedInstitute?.instituteId,'INSTITUTE_DOMAIN',state);
    // let message = `After Completing ${program_name} from ${institute_name}, you mentioned that you became self-employed. Please provide the details of first project you took after your program completion from the institute`        
    let message = `Which company did you join after your ${program_name} from ${institute_name}`;

    useEffect(() => {
        const domain = addUserSpecificDomains(new Map([...globalState.domain]), data);

            const jobRoleCodeDomain = domain.get('FREELANCING_JOB_ROLE_CODE');
            if (jobRoleCodeDomain) {
                domain.set('JOB_ROLE_CODE', jobRoleCodeDomain);
            }
  
            dispatch({
                    type: 'DATA_INIT',
                    payload: { formConfig, data, domain, routeInfo },
                });
            }, []);

    useEffect(() => {
        if (redirectUrl !== '') {
            navigate(redirectUrl);
        }
    }, [redirectUrl]);

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            {/* <FreeLancingWorkLayout>{!state.flags.isDataLoading && <PageBuilder data={message}/>}</FreeLancingWorkLayout> */}
            <OutcomeInformationLayout description={message}>{!state.flags.isDataLoading && <PageBuilder />}</OutcomeInformationLayout>
        </SmartContext.Provider>
    );
};

export default FreeLancingWorkOutcome;
